import React from 'react'
import {  TableLoader } from '../../../commons'
import StatementTableData from '.';
import { DetailedProfitLossDataType } from '../../../../redux/reports/reportsType';
import "../index.scss";
import GroupingTableHeader from '../GroupingTableHeader';
import { getData } from '../common';
import { currencySignAndNegativeValueAdjust } from '../../../../utils/commonFunctions';

export const tableHeader=[{
    label: 'ACCOUNT NAME',
    value: 'account_name',
    checked: true,
    defaultChecked: true
},{
    label: 'AMOUNT',
    value: 'amount',
    checked: true,
    defaultChecked: true
}]

type AppProps={
    data:DetailedProfitLossDataType;
    fetching:boolean;
    currencySign: string | undefined;
    startDate:string;
    endDate:string;
    finalRedirectLink:{ pathname: string };
    isLedgerStatementPresent?:boolean;
    selectedBranchId?:number|null;
    branchName?:string;
}

const ExpenseTable = ({
    data,
    fetching,
    currencySign,
    finalRedirectLink,
    startDate,
    endDate,
    isLedgerStatementPresent,
    selectedBranchId,branchName
}:AppProps) => {

    const renderBody=()=>{
        let finalData=getData(data?.expenses)?.map((singleData:any,index:number)=>{
            return <StatementTableData  
            singleData={singleData} 
            count={1} 
            index={index + 1}
            startDate={startDate}
            endDate={endDate}
            currencySign={currencySign} 
            finalRedirectLink={finalRedirectLink}
            isLedgerStatementPresent={isLedgerStatementPresent}
            selectedBranchId={selectedBranchId}
            branchName={branchName}
            />
           })
           return finalData
    }

    const renderFooter=()=>{
        let finalData=tableHeader?.map((thead: any) => {
            if (thead?.value === "account_name") {
                return <td style={{borderTop:"none"}}><p className={'reports-total'}>TOTAL EXPENSES</p></td>
            }
            if (thead?.value === "amount") {
                return <td style={{borderTop:"none"}}> <p className={'reports-total'}>{currencySignAndNegativeValueAdjust(currencySign,data?.total_expense?data?.total_expense?.toFixed(2)?.toString():"0")}</p> </td>
            }
        })
        return finalData
    }

    return (
        <>
       { fetching ? <TableLoader
          Rows={10}
          ColumnPerRow={8}
        /> :
        <div className='grouping'>
         <table className='table table-bordered'>
            <thead className='sticky-table-header-without-zindex' >
                <GroupingTableHeader tableHeader={tableHeader} />
            </thead>
            <tbody>
                {renderBody()}
            </tbody>
            <tfoot>
                {renderFooter()}
            </tfoot>
        </table>
        </div>
        }
        </>
       
    )
}

export default ExpenseTable